import { takeLatest } from "redux-saga/effects";
// import * as ACTIONS from "../../action-types/user";
import * as WORKERS from "../workers/stores";
import { STORES_FAVORITE_GET_REQUEST_ACTION, STORES_LIST_GET_REQUEST_ACTION } from "../../actions/stores";

export function* watchSaga() {
  yield takeLatest(STORES_FAVORITE_GET_REQUEST_ACTION, WORKERS.getFavoriteStores);
  yield takeLatest(STORES_LIST_GET_REQUEST_ACTION, WORKERS.getStoresList);
}
